<template>
  <div class="content">
    <div class="black-top">
      <div class="arciverdio">
        <p class="label">See archive</p>
        <label class="switch">
          <input type="checkbox" v-model="archive" />
          <span class="slider round"></span>
        </label>
      </div>
      <div class="top-menu w-clearfix">
        <div class="check w-clearfix w-checkbox">
          <input
            type="checkbox"
            name="selectall"
            data-name="Selectall"
            class="checkbox w-checkbox-input"
          />
          <label class="checkbox-label w-form-label"></label>
        </div>
        <div class="options-left">
          <!-- <dropdown v-if="this.collection && 1==2" :schema="this.collection.fields" title="Fields" /> -->
          <input
            v-model="search"
            type="text"
            maxlength="256"
            placeholder="search"
            id="search-box"
            autocomplete="off"
            class="search"
          />
          <a
            class="button w-button black"
            :style="!downloadingData&&activeList&&activeList!='waiting'?'':'opacity:0.5;cursor:wait;'"
            @click.alt="!downloadingData&&activeList&&activeList!='waiting'?downloadCSV('ctrl'):''"
            @click.exact="!downloadingData&&activeList&&activeList!='waiting'?downloadCSV(Col):''"
          >
            Download Data
            <Spinner v-if="downloadingData" zoom="0.2" color="#4F8CF7" />
          </a>
          <a href="#" class="erase w-button">x</a>
          <router-link :to="'/item/'+$route.params.col+'/new-item'" class="button w-button">New Item</router-link>
        </div>
      </div>
    </div>
    <div class="main-list w-list-unstyled" v-if="activeList && primary">
      <router-link
        :to="'/item/'+$route.params.col+'/'+item._id"
        class="main-list-item"
        v-for="item in searchRes"
        :key="item._id"
      >
        <div class="check w-clearfix w-checkbox">
          <input type="checkbox" :id="item.slug" class="checkbox w-checkbox-input" />
          <label :for="item.slug" class="checkbox-label dark w-form-label"></label>
        </div>

        <h5 class="item-head">{{item[primary]}}</h5>

        <p
          v-for="title in collection.fields.filter(e=>{return e.show == true})"
          :key="title.slug"
        >{{item[title.slug]}}</p>

        <i v-if="item._editing">being edited by {{item._editing}}</i>
        <!-- <p v-if="schema.status" class="date">{{item.status?getStatus(item.status):''}}</p> -->
        <div :class="item._draft ? 'draft' : item._archived ? 'archived':'published'"></div>
      </router-link>
      <div class="noitems" v-if="!activeList.length">
        <img src="@/assets/no_items_yet.svg" />
      </div>
      <loader v-if="activeList==='waiting'" zoom="1" />
    </div>
  </div>
</template>

<script>
import loader from "@/components/loader.vue";
import Spinner from "@/uiComponents/spinnerLoading.vue";
import dropdown from "@/uiComponents/dropdown.vue";
import { setTimeout } from "timers";

export default {
  name: "app",
  props: ["activeList", "collection"],
  components: { loader, Spinner, dropdown },
  data() {
    return {
      downloadingData: false,
      archive: false,
      search: "",
      loader: false,
      Col: "",
      fbDB: "",
      primary: "name"
    };
  },
  methods: {
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";
      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";
          line += array[i][index];
        }
        str += line + "\r\n";
      }
      return str;
    },
    exportCSVFile(headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers);
      }
      var jsonObject = JSON.stringify(items);
      var csv = this.convertToCSV(jsonObject);
      var exportedFilenmae = fileTitle + ".csv" || "export.csv";
      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    getCSVInfo(headers, multivars) {
      var itemsFormatted = [];
      $.each(this.activeList, (i, e) => {
        let fieldtxt = "";
        let obj = {};
        $.each(headers, (slug, text) => {
          if (e[slug]) {
            if (multivars[slug]) {
              var colid = multivars[slug].value;
              if (multivars[slug].type == "ItemRefSet") {
                obj[slug] = "";
                $.each(e[slug], (index, item) => {
                  if (index + 1 < e[slug].length) {
                    var sep = " | ";
                  } else {
                    var sep = "";
                  }
                  var RefItem = this.$parent.items[colid].find(e => {
                    return e._id == item;
                  });
                  if (RefItem) {
                    obj[slug] += RefItem.name.replace(/,/gi, "") + sep;
                  }
                });
              } else {
                obj[slug] = this.$parent.items[colid].find(e => {
                  return e.id == e[slug];
                }).name;
              }
            } else {
              var div = document.createElement("div");
              $(div).html(e[slug]);
              obj[slug] = $(div)
                .text()
                .replace(/[\n,]/gi, "");
            }
          } else {
            obj[slug] = "";
          }
        });
        itemsFormatted.push(obj);
        if (i + 1 == this.activeList.length) {
          var fileTitle = this.collection.name; // or 'my-unique-title'
          this.exportCSVFile(headers, itemsFormatted, fileTitle);
        }
      });
    },
    downloadCSV(ctrl) {
      downloadCSV(this.Col);
      return;
      var headers = {};
      var multivars = {};
      this.downloadingData = false;
      var schema = this.collection.fields;
      if (ctrl) {
        headers._id = "objectID";
      }
      $.each(this.collection.fields, (i, e) => {
        if (
          e.type == "PlainText" ||
          e.type == "RichText" ||
          e.type == "Number" ||
          e.type == "Link" ||
          e.type == "ItemRefSet" ||
          e.type == "ItemRef"
        ) {
          headers[e.slug] = e.name;
        }

        if (e.type == "ItemRefSet" || e.type == "ItemRef") {
          multivars[e.slug] = {
            type: e.type,
            value: e.validations.collectionId
          };
          if (!this.$parent.items[e.validations.collectionId]) {
            this.$parent.getFirebase(e.validations.collectionId);
            this.downloadingData = true;
          } else {
            if (i + 1 == schema.length) {
              this.downloadingData = false;
            }
          }
        }
        if (i + 1 == schema.length) {
          if (this.downloadingData) {
            console.log("Timing Out");
            setTimeout(() => {
              this.downloadCSV();
            }, 1000);
            return;
          } else {
            console.log("running with it");
            if (i + 1 == schema.length) {
              this.downloadingData = false;
              this.getCSVInfo(headers, multivars);
            }
          }
        }
      });
    }
  },
  afterRouteUpdate(to, from, next) {
    this.primary = this.collection.fields.find(e => e.primary == true)
      ? this.collection.fields.find(e => e.primary == true).slug || "name"
      : "name";
  },
  beforeRouteUpdate(to, from, next) {
    this.loader = true;
    this.Col = to.params.col;
    this.$parent.getFirebase(this.Col);
    this.$emit("changeList", this.Col);
    next();
  },
  mounted() {
    window.app = this;
    this.Col = this.$route.params.col;
    this.$emit("changeList", this.Col);
    this.$parent.getFirebase(this.Col);
  },
  computed: {
    searchRes() {
      if (this.activeList == "waiting") {
        return [];
      }
      if (this.search) {
        return this.activeList.filter(e =>
          e[this.primary].match(new RegExp(this.search, "gi"))
        );
      } else if (this.archive) {
        return this.activeList.filter(e => e._archived == true);
      } else {
        return this.activeList.filter(e => e._archived != true);
      }
    }
  }
};
</script>

<style scoped>
.slider {
  background-color: #363a3e;
}
.label {
  margin-top: 10px;
  margin-right: 15px;
  float: left;
}
.rtl .arciverdio {
  float: right;
  margin-right: 43px;
}
.arciverdio {
  float: left;
  margin: 20px;
  margin-left: 43px;
}
@media screen and (max-width: 767px) {
  .arciverdio {
    margin: 28px;
  }
  .label {
    margin-top: 0px;
    margin-right: 0px;
    display: none;
    float: none;
  }
}
.top-menu {
  padding-top: 20px;
}
</style>